const pageSidebarType = 'PAGE_SIDEBAR';
const pageSidebarWideType = 'PAGE_SIDEBAR_WIDE';
const pageSidebarLightType = 'PAGE_SIDEBAR_LIGHT';
const pageSidebarMinifyType = 'PAGE_SIDEBAR_MINIFY';
const pageSidebarToggledType = 'PAGE_SIDEBAR_TOGGLED';
const pageSidebarTransparentType = 'PAGE_SIDEBAR_TRANSPARENT';

const initialState = {
    pageSidebar: true,
    pageSidebarWide: false,
    pageSidebarLight: false,
    pageSidebarMinify: false,
    pageSidebarToggled: false,
    pageSidebarTransparent: false,
};

export const sidebarActions = {
    handleSetPageSidebar: () => ({ type: pageSidebarType }),
    handleSetPageSidebarWide: () => ({ type: pageSidebarWideType }),
    handleSetPageSidebarLight: () => ({ type: pageSidebarLightType }),
    handleSetPageSidebarMinified: () => ({ type: pageSidebarMinifyType }),
    handleSetPageSidebarToggled: () => ({ type: pageSidebarToggledType }),
    handleSetPageSidebarTransparent: () => ({ type: pageSidebarTransparentType }),

    //handleSidebarOnMouseOut: () => ({ type: pageSidebarToggledType }),
    //handleSidebarOnMouseOver: () => ({ type: pageSidebarToggledType }),
    toggleSidebarMinify: () => ({ type: pageSidebarMinifyType }),
    toggleMobileSidebar: () => ({ type: pageSidebarToggledType }),
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case pageSidebarType:
            return { ...state, pageSidebar: !state.pageSidebar };

        case pageSidebarWideType:
            return { ...state, pageSidebarWide: !state.pageSidebarWide };

        case pageSidebarLightType:
            return { ...state, pageSidebarLight: !state.pageSidebarLight };

        case pageSidebarMinifyType:
            return { ...state, pageSidebarMinify: !state.pageSidebarMinify };

        case pageSidebarToggledType:
            return { ...state, pageSidebarToggled: !state.pageSidebarToggled };

        case pageSidebarTransparentType:
            return { ...state, pageSidebarTransparent: !state.pageSidebarTransparent };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/admin/sidebar.js